import React from 'react';
import { Button, Form, Space, InputNumber, notification } from 'antd';
import axios from '../shared/axios';

const baseURL = process.env.REACT_APP_BACKEND_URL;

const layout = {
  labelCol: {
    span: 18,
  },
  wrapperCol: {
    span: 18,
  },
};
const tailLayout = {
  wrapperCol: {
    offset: 8,
    span: 16,
  },
};

const MergeAccounts = (props) => {
  const [form] = Form.useForm();

  const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
      message,
      description,
    });
  };

  const onReset = () => {
    form.resetFields();
  };

  const mergeAccounts = async (params) => {
    try {
      const response = await axios.post(`${baseURL}/merge-accounts`, params);
      openNotificationWithIcon('success', 'Success', response?.data?.message);
    } catch (error) {
      openNotificationWithIcon(
        'error',
        'Failure',
        `Migration failed from ${params?.fromLearnerId} to ${params?.toLearnerId} due to ${error?.message}`
      );
    }
  };

  return (
    <>
      <Space align="baseline">
        <Form align="center" {...layout} form={form} onFinish={mergeAccounts}>
          <Form.Item
            name="fromLearnerId"
            label="Enter learner Id to merge from"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <InputNumber />
          </Form.Item>
          <Form.Item
            name="toLearnerId"
            label="Enter learner Id to merge to"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <InputNumber />
          </Form.Item>
          <Form.Item {...tailLayout}>
            <Button type="primary" htmlType="submit">
              Merge Accounts
            </Button>
            <Button htmlType="button" onClick={onReset}>
              Reset
            </Button>
          </Form.Item>
        </Form>
      </Space>
    </>
  );
};

export default MergeAccounts;
